<template>
    <main class="pd-main">
        <div class="main-content">
        <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
            <div class="card" v-else>
                <header class="no-border">
                    <div class="header-bar flexbox pl-20">
                        <h4>Edit Profile</h4>
                    </div>
                </header>
                <div class="card-body">
                        <form>
                            <div class="avatar avatar-xxl">
                                    <img v-if="avatar.id == null" src="../../assets/static/img/avatar.jpg">
                                    <img v-else :src="avatar.url">
                            </div>
                            <div class="form-group">
                                <label>Choose a profile picture from the catalogue: </label>
                                <div class="flex justify-content-start mb-20">
                                    <span v-for="(avatar, i) in avatars" :key="i">
                                        <a @click="chooseAvatar(avatar.id)" href="#">
                                            <img class="avatar b-1 border-primary mr-10" :id="avatar.id" :src="avatar.secure_url" alt="..." />
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <hr class="mb-10 mt-10" />
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label>First Name</label>
                                    <input class="form-control" type="text" id="fname" @blur="$v.fname.$touch()" v-model="fname"/>
                                    <div v-if="$v.fname.$dirty">
                                        <div class="custom-error" v-if="!$v.fname.required">*Your first name is required.</div>
                                    </div>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Last Name</label>
                                    <input class="form-control" type="text" id="lname" @blur="$v.lname.$touch()" v-model="lname"/>
                                    <div v-if="$v.lname.$dirty">
                                        <div class="custom-error" v-if="!$v.lname.required">*Your last name is required.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label>Phone Number</label>
                                    <input class="form-control" type="text" id="phone" v-model="phone"/>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Email</label>
                                    <input disabled class="form-control" type="text" id="email"  @blur="$v.email.$touch()" v-model="email"/>
                                    <div v-if="$v.email.$dirty">
                                        <div class="custom-error" v-if="!$v.email.required">*Your Email is required.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label>Nickname</label>
                                    <input class="form-control" type="text" id="nickname" @blur="$v.nickname.$touch()" v-model="nickname">
                                    <div v-if="$v.nickname.$dirty">
                                        <div class="custom-error" v-if="!$v.nickname.required">*A nickname is required.</div>
                                    </div>
                                </div>
                                <div class="col-md-6 form-group">
                                        <label for="gender">Gender</label>
                                        <multiselect v-model="gender" :options="['Male', 'Female']" @blur="$v.gender.$touch()"
                                        :close-on-select="true" :show-labels="false" placeholder="Choose:">
                                        </multiselect>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label for="birth_month">Birth Month</label>
                                    <multiselect v-model="birthmonth" :options="month_list" 
                                    :close-on-select="true" :show-labels="false" placeholder="Select your month">
                                    </multiselect>
                            </div>
                            <div class="col-md-6 form-group">
                                    <label for="birth_year">Birth Year</label>
                                    <input type="number" class="form-control py-10" v-model="birthyear" id="birthyear">
                                    <div v-if="$v.birthyear.$dirty">
                                        <div class="custom-error" v-if="!$v.birthyear.required">*Please enter your year of birth.</div>
                                        <div class="custom-error" v-if="!$v.birthyear.minLength || !$v.birthyear.maxLength">*Year must be 4 digits</div>
                                    </div>
                            </div>
                            </div>  
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="issues">Issues to Support</label>
                                        <multiselect v-model="issues" :options="issues_list" track-by="id" label="title"  :multiple="true" 
                                        :close-on-select="true" :show-labels="false" placeholder="Pick issues:">
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group form-type-line">
                                        <label for="languages">Fluent Languages</label>
                                        <multiselect v-model="languages" :options="language_list" track-by="id" label="name" :multiple="true" 
                                        :close-on-select="true" :show-labels="false" placeholder="Select languages:">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                                <button class="mb-10 btn btn-sm btn-bold btn-primary" disabled v-if="loading">
                                    <circle-spin class="m-0"></circle-spin>
                                </button>
                                <button class="mb-10 btn btn-sm btn-bold btn-primary" v-else :disabled="$v.$invalid || checkData" @click="saveProfile" type="button">Save</button>
                            </form>
                </div>
                    
            </div>
        </div>
    </main>
</template>

<script>
import axios from "axios";
import allMixins from '../../mixins.js'
import {
  required,
  email,
  numeric, minLength, maxLength,
  sameAs
} from "vuelidate/lib/validators";

export default {
    name: "editMember",
    mixins: [allMixins],
    data() {
        return {
            firstLoad: true,
            loading: false,
            seekerId: null,
            fname: '',
            lname: '',
            email: '',
            phone: '',
            nickname: '',
            gender: '',
            birthmonth: '',
            month_list: ['January','February','March','April','May','June','July','August','September','October',
            'November','December'],
            birthyear: '',
            issues: [],
            issues_list: [],
            languages: [],
            language_list: [],
            avatar: {},
            avatars: [],
            userDetails: {}
        }
    },
    validations: {
        fname: { required },
        lname: { required },
        nickname: { required },
        email: {
        required,
        email
        },
        birthyear: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4)
        },
        confirm_password: {
        sameAsPassword: sameAs("password")
        }
    },
    computed: {
        checkData() {
            if(this.birthmonth == "" || this.gender == "" || this.languages.length < 1 || this.issues.length < 1) {
                // || this.image == null
                return true
            }
            else {
                return false
            }
        },
    },
    methods: {
        chooseAvatar(payload) {
            if(this.avatar.id != null) {
                document.getElementById(`${this.avatar.id}`).classList.remove('b-3')
                document.getElementById(`${this.avatar.id}`).classList.add('b-1')
            }
            
            document.getElementById(`${payload}`).classList.remove('b-1')
            document.getElementById(`${payload}`).classList.add('b-3')
            this.avatar.id = payload
            // console.log(this.avatar.id)
        },
        saveProfile() {
            this.loading = true
            let issues_id = []
            let languages_id = []
            for(var i=0; i < this.issues.length; i ++){
                issues_id.push(this.issues[i].id);
                }
            for(var i=0; i < this.languages.length; i ++){
                languages_id.push(this.languages[i].id);
            }
            let userData = {
                firstname: this.fname,
                lastname: this.lname,
                phone: this.phone,
                gender: this.gender,
                nickname: this.nickname
            }
            let memberData = {
                seekerId: this.seekerId,
                birthmonth: this.birthmonth,
                birthyear: this.birthyear,
                issues: issues_id,
                languages: languages_id,
                avatar: this.avatar.id
            }
            axios.patch('/users/update', userData)
            .then(res => {
                axios.patch('/users/u/update/?u=seeker', memberData)
                .then( res => {
                    this.loading = false
                    this.$notify({
                            group: 'response',
                            type: 'success',
                            text: 'Profile updated Successfully',
                            duration: 2500,
                    })
                    setTimeout(() => {
                        location.reload()
                    }, 3000)
                })
                .catch(err => {
                    this.loading = false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                    });
                })
            })
            .catch(err => {
                this.loading = false
                this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                });
            })
        }
    },
    mounted() {
        this.firstLoad = true
        let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
        axios.get(`users/find/${details.id}`)
        .then(res => {
            this.fname = res.data.user_details.firstname
            this.lname = res.data.user_details.lastname
            this.email = res.data.user_details.email
            this.phone = res.data.user_details.phone
            this.gender = res.data.user_details.gender
            this.nickname = res.data.user_details.nickname
            this.issues = res.data.seeker[0].Issues
            this.seekerId = res.data.seeker[0].id
            this.languages = res.data.seeker[0].Languages
            this.birthmonth = res.data.seeker[0].birthmonth
            this.birthyear = res.data.seeker[0].birthyear
            this.avatar = {id: res.data.seeker[0].avatar, url: res.data.seeker[0].avatars[0].secure_url}
            axios.get('/admin/list?type=issue')
            .then(res => {
                let issues = res.data.data
                for(var i=0; i < issues.length; i ++){
                this.issues_list.push({id: issues[i].id, title: issues[i].title});
                }
                axios.get('/admin/list?type=language')
                .then(res => {
                    let languages = res.data.data
                    for(var i=0; i < languages.length; i ++){
                        this.language_list.push({id: languages[i].id, name: languages[i].name});
                    }
                    axios.get('/users/avatars/all')
                    .then(res => {
                        this.avatars = res.data.results
                        this.firstLoad = false
                    })
                    .catch(err => {
                        this.firstLoad = false
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000,
                        });
                    })
                })
                .catch(err => {
                    this.firstLoad = false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                    });
                })
            })
            .catch(err => {
                this.firstLoad = false
                this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                });
            })
        })
        .catch(err => {
            this.firstLoad = false
            this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
            });
        })
    }
}
</script>